module.exports = __webpack_public_path__ + "img/cv_tumbnail.6c3083bc.svg";